
export interface NoteBlobReq {
    objkbn: string;
    objcd: string;
    noteid?: string;
    orgId: string;
    fieldids?: NoteBlobKeyObject[];
}

export interface S3NoteBlobsData {
    noteId?: string;
    data: S3NoteBlobsByField[];
}

export interface S3NoteBlobsByField {
    fieldid?: string;
    preSignURL?: string;
    key: string;
    type: NoteBlobAction;
    // delflg?: boolean
}

export enum NoteBlobAction {
    Update = 1,
    Delete = 2,
    New = 3
}


export interface NoteBlobFile {
    bldata: any[],
    ext: string
}

export interface NoteBlobKeyObject {
    fieldId?: string;
    ext?: string;
}